<template>
    <div class="full-height">
        <div v-if="!status.fetching" class="full-height">
          <div v-if="arePrebuiltModelsSupported">
            <div class="prebuilt-models">
              <prebuilt-model-card
                v-bind:key="prebuiltModel.id"
                v-for="prebuiltModel in prebuiltModels"
                :contexts="contextNames"
                :prebuilt-model="prebuiltModel"
                :is-added="checkIfUsed(prebuiltModel.id)"
              />
            </div>
            <div
              v-if="prebuiltModels.length === 0"
              class="prebuilt-models--empty full-height"
            >
              {{ $t('model.nlu-model.prebuilt-models.prebuilt-models.noPrebuiltModels') }}
            </div>
          </div>
          <div v-else class="no-prebuilt-models full-height">
            {{ $t('model.nlu-model.prebuilt-models.prebuilt-models.prebuiltModelsArent') }}
          </div>
        </div>
        <BigPreloader
            v-else
            :caption="$t('model.nlu-model.prebuilt-models.prebuilt-models.preloader.caption')"
            :info="$t('model.nlu-model.prebuilt-models.prebuilt-models.preloader.info')"
        />
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import PrebuiltModelCard from './prebuilt-model-card'
import BigPreloader from '@/components/common/BigPreloader'
import { getSupportedFeatures } from '@/config'

export default {
  name: 'PrebuiltModels',

  components: {
    PrebuiltModelCard,
    BigPreloader
  },

  created () {
    this.fetchPrebuiltModels({ language: this.getCurrent.culture })
    this.fetchAllApplications()
  },

  methods: {
    ...mapActions('knowledgebase', ['fetchAllApplications']),
    ...mapActions('knowledgebase/prebuiltModels', ['fetchPrebuiltModels']),

    checkIfUsed (prebuiltModelId) {
      if (this.getCurrent && this.getCurrent.prebuiltModelIds) {
        return this.getCurrent.prebuiltModelIds.includes(prebuiltModelId)
      }
      return false
    }
  },

  computed: {
    ...mapState('knowledgebase/prebuiltModels', ['prebuiltModels', 'status']),
    ...mapState('knowledgebase', ['categories', 'allApplications']),
    ...mapGetters('knowledgebase', ['getCurrent']),

    contextNames () {
      return this.allApplications.map(category => ({
        id: category.id,
        name: category.name
      }))
    },

    arePrebuiltModelsSupported () {
      return getSupportedFeatures(this.getCurrent.culture).prebuiltDomain
    }
  },

  watch: {
    prebuiltModels: {
      handler (value) {
        console.log('prebuiltModels:', value)
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
.full-height {
  height: 100%
}
.prebuilt-models {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(auto-fill, 240px);
  padding: $sp-3 0;
}
.prebuilt-models--empty, .no-prebuilt-models {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
</style>
